import { useRef, MutableRefObject, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { makeStyles } from '@material-ui/core';
import { fetchEntities } from '../../redux/entities';
import { AppDispatch } from '../../store';
import { getAppConfig, logUserLogout, redirectToLogin } from '../../utils';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    height: '100%'
  },
  iframeStyle: {
    flexGrow: 1,
    border: 1
  }
}));

export const Reports = () => {
  const jurisdictionId = Number(useParams<{ jurisdictionId: string }>().jurisdictionId);
  const classes = useStyles();
  const dispatch = useDispatch<AppDispatch>();
  const iframeRef = useRef() as MutableRefObject<HTMLIFrameElement>;

  const config = getAppConfig();
  const baseUrl = window.location.origin;
  const reportsUrl = `${baseUrl}/${config.tpUIReports}/${jurisdictionId || ''}`;

  const onHandlerWindowMessage = useCallback((e: MessageEvent) => {
    const data = typeof e?.data === 'string' ? JSON.parse(e.data) : e.data;
    if (data.kind === 'AUTH' && data.message === 'SESSION_EXPIRED') {
      void logUserLogout('session_expired');
      void redirectToLogin();
    }
  }, []);

  useEffect(() => {
    window.addEventListener('message', onHandlerWindowMessage);
    return () => {
      window.removeEventListener('message', onHandlerWindowMessage);
    };
  }, [onHandlerWindowMessage]);

  useEffect(() => {
    void dispatch(fetchEntities());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.content}>
      <iframe ref={iframeRef} className={classes.iframeStyle} src={reportsUrl} />
    </div>
  );
};
